import React from 'react';

import i18n from '../../i18n';
import { MenuItem, TextField } from '@mui/material';

// @mui

export default class DialogStateField extends React.Component {
    // field, value, onChange

    onChange(event) {
        // Was event.target.name, i.e. field.label — so the value landed under the
        // label key rather than the field id whenever the two differed.
        this.props.onChange(this.props.field.id, event.target.value);
    }

    render() {
        // field, value, cache, onChange

        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        let id = this.props.field.id;
        let name = this.props.field.label;
        let value = this.props.value ? this.props.value.toLowerCase() : '';


        return (
            <TextField
                key={id}
                select
                id={id}
                name={name}
                label={translatedName}
                required={Boolean(this.props.field.required)}
                error={Boolean(this.props.error)}
                helperText={this.props.error || ''}
                // Controlled, so a reset or template application is reflected.
                value={value}
                fullWidth
                onBlur={this.props.onBlur}
                onChange={(event) => this.onChange(event)}>
                {
                    this.props.field.items.map(item => (
                        <MenuItem key={item} value={item.toLowerCase()}>
                            {i18n.t(`enums.${item}`)}
                        </MenuItem>
                    ))
                }
            </TextField>
        );
    }
}